// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__S0ulX","icon":"style_icon__2ZRHK","message":"style_message__BSAW-"};